import { ITile } from '@varo/graphql-schema-types';
import { TileAdapterMap } from 'features/home/HomeScreen/adapters/adapterMap/types';
import { HomeCardDependencies } from 'features/home/HomeScreen/dependencies/types';
import { VXLNode } from 'shared/renderer/types';
import { isNotNil } from 'shared/utils/isNotNil/isNotNil';

/**
 * maps tiles to VXLNodes using a defined set of adapter functions.
 */
const mapHomeTiles = (
  adapterMap: TileAdapterMap,
  tiles: ITile[],
  dependencies: HomeCardDependencies,
): VXLNode[] => {
  return tiles
    .map((tile) => {
      const adapter = adapterMap[tile.tileType];
      if (!adapter) {
        return null;
      }

      return adapter(tile, dependencies);
    })
    .filter(isNotNil);
};

export default mapHomeTiles;
